import React from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Hidden
} from "@material-ui/core";

const NoDiceModalMessage = props => {
  const close =
    props && props.actions && `function` === typeof props.actions.close
      ? props.actions.close
      : () => undefined;

  return (
    <>
      <DialogTitle>Um&hellip;Help?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please choose at least one die to roll. We're not (that) psychic.
        </DialogContentText>
        <Hidden smDown implementation="css">
          <DialogContentText>
            You can find the settings in the <strong>Control Panel</strong> on
            the left side of the screen.
          </DialogContentText>
        </Hidden>
        <Hidden mdUp implementation="css">
          <DialogContentText>
            You can change the settings by tapping <strong>Change Dice</strong>.{" "}
          </DialogContentText>
        </Hidden>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Got It</Button>
      </DialogActions>
    </>
  );
};

export default NoDiceModalMessage;
